import { EventTypeGroup } from './EventTypeGroup';
import { RotationTreeEnum } from '../../enums/rotationTreeEnum';

export class EventTypeLevel {
    constructor(eventTypeLevelId: RotationTreeEnum, eventTypeLevelName: string, eventTypeContextId: number, eventTypeGroupArray: EventTypeGroup[]) {
        this.eventTypeLevelId = eventTypeLevelId;
        this.eventTypeLevelName = eventTypeLevelName;
        this.eventTypeContextId = eventTypeContextId;
        this.eventTypeGroupArray = eventTypeGroupArray;
    }
    eventTypeLevelId: RotationTreeEnum;
    eventTypeLevelName: string;
    eventTypeContextId: number;
    eventTypeGroupArray: EventTypeGroup[];
}
